module.exports = __webpack_public_path__ + "img/BreakProf.ca65c397.png";